import { render, staticRenderFns } from "./DialogDeletar.vue?vue&type=template&id=a8eea844&scoped=true"
import script from "./DialogDeletar.vue?vue&type=script&lang=js"
export * from "./DialogDeletar.vue?vue&type=script&lang=js"
import style0 from "./DialogDeletar.vue?vue&type=style&index=0&id=a8eea844&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8eea844",
  null
  
)

export default component.exports